import React, { useState, useRef, useEffect } from "react";
import InnoIcons from "@InnoIcons/";
import SC from "./style";
import { InputField } from "@components/";
import { validtionMessages } from "utils/config";
import theme from "@theme/";

const EmailFilterDropdown = ({
  label,
  headerOptionsValuename = "File Name",
  selectedHeaderId,
  value = "", // single input value
  onHeaderChange,
  onUpdate,
  emails,
  setEmails,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);
  const [inputValue, setInputValue] = useState();
  const [errorKeys, setErrorKeys] = useState({}); // ✅ error tracking
  const dropdownRef = useRef();

  const headerOptions = [
    { id: "equals", label: `${headerOptionsValuename} = (equals)` },
    { id: "not-equals", label: `${headerOptionsValuename} != (not equals)` },
  ];

  const selectedHeader = headerOptions.find((h) => h.id === selectedHeaderId);

  const handleHeaderOptionClick = (headerId) => {
    onHeaderChange(headerId);
    setIsHeaderExpanded(false);
  };

  // ✅ Add email when pressing Enter or Comma
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const trimmed = inputValue.trim().replace(/,$/, "");
      if (!trimmed) return;

      if (!validateEmail(trimmed)) {
        setErrorKeys({ email: true });
      } else if (!emails.includes(trimmed)) {
        setEmails([...emails, trimmed]);
        setErrorKeys({}); // clear error if valid
      }
      setInputValue("");
    }
  };

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const removeEmail = (email) => {
    setEmails(emails.filter((e) => e !== email));
  };

  const handleUpdate = () => {
    onUpdate({ headerId: selectedHeaderId, value: emails });
    setIsOpen(false);
  };

  const handleClear = () => {
    setInputValue("");
    setEmails([]);
    setErrorKeys({});
    onUpdate({ headerId: selectedHeaderId, value: "", emails: [] });
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setIsHeaderExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <SC.DropdownContainer ref={dropdownRef}>
      <SC.DropdownButton
        isOpen={isOpen}
        isActive={value.length > 0}
        onClick={() => setIsOpen(!isOpen)}
        style={{ display: "flex", alignItems: "center", gap: "6px" }}
      >
        {value.length > 0 ? (
          <>
            <span>
              {label}:{" "}
              {selectedHeader?.id === "equals"
                ? "="
                : selectedHeader?.id === "not-equals"
                ? "!="
                : ""}{" "}
              {value[0]}
            </span>
            {value.length > 1 && (
              <span
                style={{
                  backgroundColor: "#F1980A",
                  color: "#fff",
                  borderRadius: "4px",
                  padding: "2px 6px",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                +{value.length - 1}
              </span>
            )}
          </>
        ) : (
          <span>{label}</span>
        )}
        <SC.ChevronIcon size={14} isOpen={isOpen} isActive={value.length > 0} />
      </SC.DropdownButton>

      <SC.DropdownMenu isOpen={isOpen}>
        <SC.DropdownHeader
          isClickable
          onClick={() => setIsHeaderExpanded(!isHeaderExpanded)}
        >
          <SC.HeaderText>{selectedHeader?.label}</SC.HeaderText>
          <SC.HeaderChevron isExpanded={isHeaderExpanded} />
        </SC.DropdownHeader>

        <SC.HeaderOptionsContainer isVisible={isHeaderExpanded}>
          {headerOptions.map((header) => (
            <SC.HeaderOption
              key={header.id}
              isSelected={header.id === selectedHeaderId}
              onClick={() => handleHeaderOptionClick(header.id)}
            >
              {header.label}
            </SC.HeaderOption>
          ))}
        </SC.HeaderOptionsContainer>

        {/* ✅ Input field */}
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "5px",
            display: "flex",
            marginTop: "15px",
            alignItems: "center",
            background: "#fff",
            height: "36px",
          }}
        >
          <InputField
            name="additionalEmail"
            type="email"
            placeholder="Enter mail"
            value={inputValue}
            onChange={(_, value) => setInputValue(value)}
            onKeyDown={handleKeyDown}
            style={{
              border: "none",
              outline: "none",
              flex: 1,
              fontSize: "14px",
              padding: "6px",
            }}
          />
        </div>

        {/* ✅ Chips below input */}
        <SC.OptionsList>
          {emails.map((email, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "#fff7ed",
                border: "1px solid #facc15",
                borderRadius: "6px",
                padding: "6px 10px",
                fontSize: "13px",
                color: "#444",
                marginRight: "6px",
              }}
            >
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  flex: 1, // takes remaining space
                  marginRight: "8px", // space from delete button
                }}
                title={email} // show full email on hover
              >
                {email}
              </span>
              <button
                onClick={() => removeEmail(email)}
                style={{
                  border: "none",
                  background: `${theme.colors.themeColor}`,
                  color: "#fff",
                  fontSize: "10px",
                  cursor: "pointer",
                  flexShrink: 0,
                  borderRadius: "20px",
                  width: "20px",
                  height: "18px",
                }}
              >
                ✕
              </button>
            </div>
          ))}

          {errorKeys.email && (
            <SC.ValidtionMessages>
              {validtionMessages.email}
            </SC.ValidtionMessages>
          )}
        </SC.OptionsList>

        <SC.DropdownFooter>
          <SC.UpdateButton onClick={handleUpdate}>Update</SC.UpdateButton>
          <SC.ClearButton onClick={handleClear}>Clear</SC.ClearButton>
        </SC.DropdownFooter>
      </SC.DropdownMenu>
    </SC.DropdownContainer>
  );
};

export default EmailFilterDropdown;
